define.alias("shared/components/shared/social/instagram-connect-modal", "preview-grid/components/shared/social/instagram-connect-modal");